import axios from 'axios';
import { getToken } from '../../helpers';

export const defaultParams = () => (
  {
    headers: getToken(),
  });

export default axios;
